@import "../../global/visualization-base.scss";

:host {
  @include chart-host;
}

.chart {
  @include bar-charts;

  &-link {
    @include legend-link;
    text-decoration: underline;
  }

  &__axis {
    path {
      @include axis-lines;
    }
  }

  &__average-line {
    stroke-width: 2;
  }

  &__legend {
    &--dot {
      @include legend-dot;
      margin-top: 1px;
    }

    &--row-container {
      > .uui-dv-legend-label:last-child {
        > .chart__legend--dot {
          margin-bottom: 0;
        }
      }
    }
  }

  &__tooltip {
    @include tooltip;

    &--detailed {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 8px;
    }
  }

  &--hidden {
    display: none;
  }
}
